import axios from 'axios/index';

export default function addEditLocation(location, config) {
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${localStorage.getItem('jwtToken')}`,
    'x-location-id': localStorage.getItem('locationId')
  };

  const url = config.postLocations;
  return dispatch => dispatch({
    type: 'ADD_EDIT_LOCATION_SAVE',
    payload: axios({ method: 'post', url, headers, data: { location } })
  });
}



// WEBPACK FOOTER //
// ./src/actions/addEditLocation.js